import React, { useState } from "react";
import PropTypes from "prop-types";
import googleMapStyles from "../../helpers/googleMapStyles";
import {
    GoogleMap as ReactGoogleMap,
    MarkerF,
    InfoWindow,
    StreetViewPanorama
} from "@react-google-maps/api";
import { useAppContext } from "../../providers/AppProvider";
import { useGoogleMaps } from "../../providers/GoogleMapsProvider";

const GoogleMap = ({
    mapStyle,
    initialCenter = { lat: 19.432608, lng: -99.133209 }, // 📌 Se usa CDMX como fallback
    darkStyle,
    className,
    showStreetView,
    ...rest
}) => {
    const { isLoaded } = useGoogleMaps();
    const {
        config: { isDark }
    } = useAppContext();

    const [showInfoWindow, setShowInfoWindow] = useState(false);
    const [mapStyles, setMapStyles] = useState(mapStyle);

    const options = {
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true,
        styles: googleMapStyles[mapStyles]
    };

    if (!isLoaded) return <div>Loading...</div>;

    return (
        <div className={`h-100 ${className}`} {...rest}>
            <ReactGoogleMap
                zoom={18}
                options={options}
                center={initialCenter}
                mapContainerStyle={{
                    width: "100%",
                    height: showStreetView ? "50%" : "100%",
                }}
            >
                {/* 📌 Se asegura que el marcador SIEMPRE se renderice */}
                {initialCenter.lat && initialCenter.lng && (
                    <MarkerF
                        onClick={() => setShowInfoWindow(!showInfoWindow)}
                        position={initialCenter}
                    >
                        {showInfoWindow && (
                            <InfoWindow
                                position={initialCenter}
                                onCloseClick={() => setShowInfoWindow(false)}
                            >
                                <div>Ubicación seleccionada</div>
                            </InfoWindow>
                        )}
                    </MarkerF>
                )}
            </ReactGoogleMap>

            {/* 📌 Se añade Street View SOLO si showStreetView es true */}
            {showStreetView && initialCenter.lat && initialCenter.lng && (
                <div style={{ width: "100%", height: "50%" }}>
                    <StreetViewPanorama
                        position={initialCenter}
                        options={{
                            pov: { heading: 100, pitch: 0 },
                            visible: true,
                        }}
                    />
                </div>
            )}
        </div>
    );
};

GoogleMap.propTypes = {
    mapStyle: PropTypes.oneOf([
        "Default",
        "Gray",
        "Midnight",
        "Hopper",
        "Beard",
        "AssassianCreed",
        "SubtleGray",
        "Tripitty",
        "Cobalt",
    ]),
    darkStyle: PropTypes.oneOf([
        "Default",
        "Gray",
        "Midnight",
        "Hopper",
        "Beard",
        "AssassianCreed",
        "SubtleGray",
        "Tripitty",
        "Cobalt",
    ]),
    className: PropTypes.string,
    showStreetView: PropTypes.bool,
    initialCenter: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
    }),
};

GoogleMap.defaultProps = {
    showStreetView: false,
};

export default GoogleMap;
